import { DeleteRoleReq, DeleteRoleRes, GetAllPermissionsReq, GetAllPermissionsRes, GetAllRolesReq, GetAllRolesRes, GetPermissionsOfRoleReq, GetPermissionsOfRoleRes, GetRoleReq, GetRoleRes, NewRoleReq, NewRoleRes, UpdateRoleReq, UpdateRoleRes } from '../interfaces/role.interface';
import { GetMeReq, GetMeRes, LoginReq, LoginRes } from '../interfaces/user.interface'
import {API} from './api'



export const getRolesService = async (data: GetAllRolesReq): Promise<GetAllRolesRes>=>{
    try {
        const res = await API.get('/v1/role');
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getPermissionsService = async (data: GetAllPermissionsReq): Promise<GetAllPermissionsRes>=>{
    try {
        const res = await API.get('/v1/role/permissions');
        return res.data;
    } catch (error) {
        throw error
    }
}

export const newRoleService = async (data: NewRoleReq): Promise<NewRoleRes>=>{
    try {
        const res = await API.post('/v1/role', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const updateRoleService = async (data: UpdateRoleReq): Promise<UpdateRoleRes>=>{
    try {
        const res = await API.put('/v1/role', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const deleteRoleService = async (data: DeleteRoleReq): Promise<DeleteRoleRes>=>{
    try {
        const res = await API.delete(`/v1/role/${data.id}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getPermissionsOfRoleService = async (data: GetPermissionsOfRoleReq): Promise<GetPermissionsOfRoleRes>=>{
    try {
        const res = await API.get(`/v1/role/permissions/${data.role_id}`, );
        return res.data;
    } catch (error) {
        throw error
    }
}